import { lazy } from 'react';
const Home = lazy(() => import('./components/Home').then((module) => ({ default: module.Home })));
const Sitemap = lazy(() => import('./components/Sitemap').then((module) => ({ default: module.Sitemap })));
const News = lazy(() => import('./components/News').then((module) => ({ default: module.News })));
const Seminar = lazy(() => import('./components/Seminar').then((module) => ({ default: module.Seminar })));
const About = lazy(() => import('./components/About').then((module) => ({ default: module.About })));
const NewsView = lazy(() => import('./components/NewsView').then((module) => ({ default: module.NewsView })));
const Search = lazy(() => import('./components/Search').then((module) => ({ default: module.Search })));


const AppRoutes = [
  {
        index: true,
        element: <Home />
    },
    {
        path: '/index',
        element: <Home />
    },
    {
        path: '/',
        element: <Home />
    },
    {
        path: '',
        element: <Home />
    },
    {
      path: '/sitemap',
      element: <Sitemap />
    },{
        path: '/more/news',
        element: <News />
    },
    {
        path: '/more/seminar',
        element: <Seminar />
    },
    {
        path: '/about',
        element: <About />
    },
    {
        path: '/views/:id',
        element: <NewsView />
    },
    {
        path: '/meetdetail/:id',
        element: <NewsView />
    },
    {
        path: '/Search/:searchname',
        element: <Search />
    }
    ,
    {
        path: '/Search',
        element: <Search />
    },
   //#endregion
];

export default AppRoutes;
